import { render, staticRenderFns } from "./Carnet.vue?vue&type=template&id=4ec36cee&scoped=true"
import script from "./Carnet.vue?vue&type=script&lang=js"
export * from "./Carnet.vue?vue&type=script&lang=js"
import style0 from "./Carnet.vue?vue&type=style&index=0&id=4ec36cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec36cee",
  null
  
)

export default component.exports